import { render, staticRenderFns } from "./ExportComponent.vue?vue&type=template&id=908b2a34&scoped=true&"
import script from "./ExportComponent.vue?vue&type=script&lang=js&"
export * from "./ExportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExportComponent.vue?vue&type=style&index=0&id=908b2a34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908b2a34",
  null
  
)

export default component.exports